import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { getGrowthbookInstance, growthbookInitPromise, isGrowthbookReady } from '../utils/growthbook';

interface Props {
  children: React.ReactElement;
}

const GrowthBookProviderWrapper = ({ children }: Props): ReactElement | null => {
  const [isLoaded, setIsLoaded] = useState(isGrowthbookReady);

  const growthBook = useMemo(() => getGrowthbookInstance(), []);

  useEffect(() => {
    if (!isLoaded) {
      growthbookInitPromise.finally(() => setIsLoaded(true));
    }
  }, [isLoaded]);

  if (!isLoaded) {
    return null;
  }

  return <GrowthBookProvider growthbook={growthBook}>{children}</GrowthBookProvider>;
};

export default GrowthBookProviderWrapper;
